// extracted by mini-css-extract-plugin
export default {"nav":"Navigation_nav__UOU1V","list":"Navigation_list__L7-1W"};